module.exports = __webpack_public_path__ + "media/common/img/help-e53505ac187899ae997c5efdc9e2eba4.svg";